export const equalsIgnoreCase = (value, target) =>
	(value || '').toLowerCase() === (target || '').toLowerCase();

export const normalizeName = (value) => (value || '').trim().toLowerCase();
